import domReady from '@wordpress/dom-ready';
import throttle from '../helpers/throttle';
import decodeHtmlEntities from '../helpers/decode-html-entities';
import removeDiacritics from '../helpers/remove-diacritics';

domReady( function () {
	const input = document.querySelector( '[rel="distributor-search"]' );
	const results = document.querySelectorAll(
		'[rel="distributor-results"] .distributors-search-result'
	);
	const noItemsMsg = document.querySelector( '.no-results' );

	const filterResults = function () {
		const value = removeDiacritics( input.value.trim().toLowerCase() );
		let found = false;

		if ( value.length === 0 ) {
			results.forEach( ( el ) => el.classList.remove( 'hidden' ) );
			noItemsMsg.style.display = 'none';
			return;
		}

		if ( value.length <= 3 ) {
			results.forEach( ( el ) => el.classList.remove( 'hidden' ) );
			noItemsMsg.style.display = 'none';
			return;
		}

		results.forEach( ( el ) => {
			const name = removeDiacritics(
				el.getAttribute( 'data-name' )?.toLowerCase() || ''
			);
			const town = removeDiacritics(
				el.getAttribute( 'data-town' )?.toLowerCase() || ''
			);
			const street = removeDiacritics(
				el.getAttribute( 'data-street' )?.toLowerCase() || ''
			);
			const zip = removeDiacritics(
				el.getAttribute( 'data-zip' )?.toLowerCase() || ''
			);

			if (
				name.includes( value ) ||
				town.includes( value ) ||
				street.includes( value ) ||
				zip.includes( value )
			) {
				// el.style.display = '';
				el.classList.remove( 'hidden' );
				// el.classList.add( 'visible' );
				found = true;
			} else {
				// el.style.display = 'none';
				el.classList.add( 'hidden' );
				// el.classList.remove( 'visible' );
			}
		} );

		noItemsMsg.style.display = found ? 'none' : 'block';
	};

	input.addEventListener( 'input', throttle( filterResults, 300 ) );

	initMap( input, results );
} );

function initMap( searchInputField, results ) {
	const theMap = document.querySelector( '[rel="distributors-locations"]' );
	const pinLocationBtn = document.querySelector( '[rel="pin-location"]' );
	const distributorPin = document.querySelectorAll( '.distributor-pin' );
	const resetMapBtn = document.querySelector( '[rel="reset-map"]' );
	const leaflet = window.L;
	const markers = window.l18n_js_map_vars.markers;
	const defaultCoords = [ 46.279, 24.598 ];
	const map = leaflet
		.map( theMap, { scrollWheelZoom: false } )
		.setView( defaultCoords, 6 );
	// let newMarker, circle, zoomed;
	leaflet
		.tileLayer( 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution:
				'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
		} )
		.addTo( map );

	markers.forEach( ( marker, i ) => {
		const icon = leaflet.icon( {
			iconUrl: marker?.icon || window.l18n_js_map_vars.icon, //switch on marker icon when the image is uploaded for each marker
			iconSize: [ 35, 35 ],
			iconAnchor: [ 12, 41 ],
			popupAnchor: [ 1, -34 ],
		} );

		const markerOptions = {
			title: decodeHtmlEntities( marker.title ),
			icon,
			clickable: true,
			draggable: false,
		};

		leaflet
			.marker( [ marker.lat, marker.lng ], markerOptions )
			.addTo( map )
			.bindPopup( marker.popupData );
		// .openPopup();
	} );

	pinLocationBtn.addEventListener( 'click', locateMe );
	resetMapBtn.addEventListener( 'click', function () {
		// const input = document.querySelector( '[rel="distributor-search"]' );
		map.setView( defaultCoords, 6 );
		searchInputField.value = '';
		results.forEach( ( result ) => {
			result.classList.remove( 'hidden' );
		} );
		// map.removeLayer( newMarker );
		// map.removeLayer( circle );
	} );

	distributorPin.forEach( ( distributor ) => {
		distributor.addEventListener( 'click', locateMarker, false );
	} );

	// const searchResults = [
	// 	...document.querySelectorAll( '.distributors-search-result' ),
	// ];
	// searchResults.forEach( ( result ) => {
	// 	result.addEventListener( 'click', locateMarker, false );
	// } );

	function locateMe() {
		// console.log( 'locateMe2' );

		// navigator.geolocation.watchPosition( success, error );
		navigator.geolocation.getCurrentPosition(
			function ( pos ) {
				const crd = pos.coords;
				map.setView(
					new leaflet.LatLng( crd.latitude, crd.longitude ),
					10
				);
			},
			function ( err ) {
				console.warn( `ERROR(${ err.code }): ${ err.message }` );
			},
			{
				enableHighAccuracy: false,
				timeout: 5000,
				maximumAge: 0,
			}
		);
	}

	function locateMarker( e ) {
		console.log( e.target );
		const lat = e.target.getAttribute( 'data-lat' );
		const lng = e.target.getAttribute( 'data-lng' );
		map.setView( new leaflet.LatLng( lat, lng ), 13 );

		console.log( lat, lng );
	}

	// function success( pos ) {
	// 	const lat = pos.coords.latitude;
	// 	const lng = pos.coords.longitude;
	// 	const accuracy = pos.coords.accuracy;
	// 	// const {
	// 	// 	coords: { lat, lng, accuracy },
	// 	// } = pos;
	// 	console.log( { accuracy, lat, lng } );
	// 	if ( newMarker ) {
	// 		map.removeLayer( newMarker );
	// 		map.removeLayer( circle );
	// 	}
	//
	// 	newMarker = leaflet.marker( [ lat, lng ] ).addTo( map );
	// 	circle = leaflet
	// 		.circle( [ lat, lng ], { radius: accuracy } )
	// 		.addTo( map );
	// 	// Adds marker to the map and a circle for accuracy
	//
	// 	if ( ! zoomed ) {
	// 		zoomed = map.fitBounds( circle.getBounds() );
	// 	}
	// 	// Set zoom to boundaries of accuracy circle
	//
	// 	map.setView( [ lat, lng ], 10 );
	// 	// Set map focus to current user position
	// }
	// function error( err ) {
	// 	if ( err.code === 1 ) {
	// 		console.warn( 'Please allow geolocation access' );
	// 	} else {
	// 		console.warn( 'Cannot get current location' );
	// 	}
	// }
}
